import React from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div className="footer padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-3 col-lg-6 col-sm-6 col-xs-12">
              <Link to="/">
                <div className="ftr-logo">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/ftr-logo.png"
                      alt="CSSK"
                    />{" "}
                  </LazyLoad>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d58981.53343931561!2d88.209192!3d22.491204!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a027c357ca4e321%3A0x7acd00b1776349d4!2sCarmel%20School!5e0!3m2!1sen!2sin!4v1787572372997!5m2!1sen!2sin"
                    width="100%"
                    height="150px"
                    frameBorder="0"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="strict-origin-when-cross-origin"
                  ></iframe>
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-lg-6 col-sm-6 col-xs-12">
              <h3>useful links</h3>
              <div className="quick-link">
                <ul>
                  <li>
                    <Link to="/photo-gallery">
                      <i className="bi bi-caret-right-fill"></i>Photo Gallery
                    </Link>
                  </li>
                  <li>
                    <Link to="/sports">
                      <i className="bi bi-caret-right-fill"></i>Sports
                      Corner{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="/aim">
                      <i className="bi bi-caret-right-fill"></i>Aim
                    </Link>
                  </li>

                  <li>
                    <Link to="/faculty" target="_blank">
                      <i className="bi bi-caret-right-fill"></i>Faculty
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-5 col-md-6 col-sm-6">
                <ul className="socialMedia">
                  <li>
                    <Link
                      to="https://www.youtube.com/channel/UCBAdSjZA7mn99xnx02191QQ"
                      target="_blank"
                    >
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/yt.png"
                        alt="STPCSH"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.instagram.com/carmel_school_sarangabad/"
                      target="_blank"
                    >
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/instagram.png"
                        alt="STPCSH"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.facebook.com/schoolcarmelsarangabad/?ref=pages_you_manage"
                      target="_blank"
                    >
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/facebook.png"
                        alt="STPCSH"
                      />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-sm-12 col-xs-12 address">
              <h3>contact details</h3>
              <p>
                <i className="bi bi-house-door-fill"></i>{" "}
                <span>
                  <Link to="" target="_blank">
                    Carmel School Sarangabad, B.B.T. Road, Maheshtala Kolkata -
                    700137
                  </Link>
                </span>
              </p>
              <p>
                <i className="bi bi-envelope-fill"></i>{" "}
                <span>
                  {" "}
                  <a href="mailto:carmelsar@gmail.com">carmelsar@gmail.com</a>
                </span>
              </p>
              <p>
                <i className="bi bi-telephone-fill"></i>{" "}
                <span>
                  <a href="tel:+91-8274010397">+91-8274010397</a>{" "}
                </span>
              </p>
            </div>
            <div className="col-xl-4 col-lg-6 col-sm-12 col-xs-12">
              <div className="ph-flex">
                <div className="app-cont">
                  <h3>Download Mobile App</h3>
                  <p>
                    {" "}
                    CampusCare 10x mobile app for parents is a tool that serves
                    as a single point of reference for parents. The app
                    centralises all the school-parent interaction and lets
                    parents stay updated with their ward's day-to-day
                    activities. Parents can receive assignments, homework, and
                    circulars, keep track of their child's attendance, do online
                    fee payment, view report cards.
                  </p>
                  <div className="d-flex ">
                    <a
                      href="https://apps.apple.com/in/app/campuscare-10x/id1611283814"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <LazyLoad>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/apple.png"
                          className="img-fluid"
                          alt="Download on App Store"
                        />
                      </LazyLoad>
                    </a>

                    <a
                      href="https://play.google.com/store/apps/details?id=com.entab.learninglab&hl=en-IN"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <LazyLoad>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/playstore.png"
                          className="img-fluid"
                          alt="Get it on Google Play"
                        />
                      </LazyLoad>
                    </a>

                    <p className="link mb-0">
                      <Link to="https://entab.online/CRMLSD" target="_blank">
                        School Code- CRMLSD
                      </Link>
                    </p>
                  </div>
                </div>
                <div className="mobile-icon">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/mobile-icon.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        ©️ Copyright 2026 by Carmel School Sarangabad, Kolkata Designed By{" "}
        <Link to="https://www.entab.in/" target="_blank">
          Entab Infotech: CampusCare®️{" "}
        </Link>
      </div>
    </>
  );
};

export default Footer;
